/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ImageFrame({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}><rect width={14} height={13} x={1} y={2} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} rx={2} /><rect width={9.537} height={8.856} x={3.247} y={4.072} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} rx={1} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m8.002 11.336-.055-.046c-.847-.718-2.536-.727-3.403-.02l-.981.802M12.784 11.582l-.94-1.31c-.62-.862-2.082-.863-2.703-.002L7.49 12.564" /><circle cx={6.637} cy={7.433} r={1.362} stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} /></svg>;
}
;